import { Dispatch, FC, SetStateAction, useEffect } from "react";

interface ResetPasswordProps {
  isOpen: boolean;
  onClose: () => void;
  handlePasswordReset: () => Promise<void>;
  resetPasswordEmail: string;
  resetPasswordSuccess: string | null;
  resetPasswordError: string | null;
  setResetPasswordEmail: Dispatch<SetStateAction<string>>;
}

const ResetPassword: FC<ResetPasswordProps> = (props) => {
  const {
    isOpen,
    onClose,
    handlePasswordReset,
    resetPasswordEmail,
    resetPasswordSuccess,
    resetPasswordError,
    setResetPasswordEmail,
  } = props;

  useEffect(() => {
    if (!isOpen) {
      return;
    }

    const handleEscape = (event: KeyboardEvent) => {
      if (event.key === "Escape") {
        onClose();
      }
    };

    window.addEventListener("keydown", handleEscape);
    return () => window.removeEventListener("keydown", handleEscape);
  }, [isOpen, onClose]);

  return (
    <div
      className="fixed bottom-0 left-0 right-0 top-0 z-10 flex items-center justify-center bg-black/70 px-4"
      style={{ transform: `translateY(${isOpen ? "0%" : "-100%"})` }}
      onMouseDown={(event) => {
        if (event.target === event.currentTarget) {
          onClose();
        }
      }}
    >
      <div className="w-full max-w-md rounded-lg border border-white/10 bg-[#24262c] p-6 shadow-2xl shadow-black/40">
        <h1 className="mb-2 text-2xl font-bold text-white">Reset Password</h1>
        <p className="mb-5 text-sm text-slate-300">
          Enter the parent email address for your account. We will send a reset
          link if the account exists.
        </p>
        <input
          type="email"
          value={resetPasswordEmail}
          onChange={(e) => setResetPasswordEmail(e.target.value)}
          onKeyDown={(event) => {
            if (event.key === "Enter") {
              handlePasswordReset();
            }
          }}
          placeholder="parent@example.com"
          className="mb-4 min-h-[46px] w-full rounded-md border border-white/15 bg-white/[0.06] px-4 py-3 text-slate-100 outline-none transition placeholder:text-slate-500 focus:border-accent-color-2 focus:ring-2 focus:ring-[rgba(108,207,246,0.2)]"
        />
        <button
          onClick={handlePasswordReset}
          className="min-h-[46px] w-full rounded-md border border-accent-color-1 bg-accent-color-1 px-4 py-3 font-bold text-white transition hover:border-[#c75a48] hover:bg-[#c75a48]"
        >
          Reset Password
        </button>
        {resetPasswordSuccess && (
          <p className="mt-3 rounded-md border border-green-300/30 bg-green-500/15 px-3 py-2 text-sm text-green-100">
            {resetPasswordSuccess}
          </p>
        )}
        {resetPasswordError && (
          <p className="mt-3 rounded-md border border-red-300/30 bg-red-500/15 px-3 py-2 text-sm text-red-100">
            {resetPasswordError}
          </p>
        )}
        <button
          onClick={onClose}
          className="mt-4 text-sm text-slate-400 underline underline-offset-4 transition hover:text-accent-color-2"
        >
          Close
        </button>
      </div>
    </div>
  );
};

export default ResetPassword;
